import axios from 'axios';
import 'chartjs-adapter-date-fns';
import { format, isValid, parse } from 'date-fns';
import {
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBChart,
  MDBCol,
  MDBContainer,
  MDBRow,
  MDBSpinner,
  MDBTable,
  MDBTypography
} from "mdb-react-ui-kit";

import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchMainPageData } from '../utils/Common';
import { NavbarContext } from '../context/NavProvider';
const Dashboard = () => {
  const [noOfDays, setNoOfDays] = useState('');
  const [statisticsData, setStatisticsData] = useState([]);
  const [allYearGraphData, setAllYearGraphData] = useState([]);
  const [companyGraphData, setCompanyGraphData] = useState([]);
  const [frequentlyBoughtData, setFrequentlyBoughtData] = useState([]);
  const [topNHigh, setTopNHigh] = useState([]);
  const { setIsPricing,pageData,setPageData,setBusiness} = useContext(NavbarContext);

  const didFetchRef = useRef(false);

  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_INVENTORY_URL;
  const getUnitForSpan = ( endDate,startDate) => {
    const spanInDays = ( startDate - endDate ) / (1000 * 60 * 60 * 24);
    if (spanInDays > 730) {
      return 'year';
    }
    if (spanInDays > 365) {
      return 'month';
    } else if (spanInDays > 30) {
      return 'week';
    } else {
      return 'day';
    }
  };

  const timeUnit = useMemo(() => {
    if (statisticsData?.data?.labels?.length > 1) {
      const startDate = new Date(statisticsData.data.labels[0]);
      const endDate = new Date(statisticsData.data.labels[statisticsData.data.labels.length - 1]);
      return getUnitForSpan(endDate, startDate);
    }
    return 'day';
  }, [statisticsData]);
  
  const formatDate = (dateString) => {
    const parsedDate = convertToDate(dateString);
    if (parsedDate) {
      return format(parsedDate, 'dd-MMM-yyyy h:mm:ssa');
    } else {
      // Handle invalid date string
      return null;
    }
  };
  const formatsToCheck = [
    "MM/dd/yyyy h:mm:ssa",
    "MM/dd/yyyy"
  ];

  useEffect(() => {
    if (!pageData) {
      fetchMainPageData(setPageData,setIsPricing,pageData,setBusiness);
      
      
    }
  }, []);

  const convertToDate = (dateString) => {
    for (const formatString of formatsToCheck) {
      const parsedDate = parse(dateString, formatString, new Date());
      if (isValid(parsedDate)) {
        return parsedDate;
      }
    }
    return null; // Return null if none of the formats match
  };
  const fetchItems = useCallback(async () => {
    let response;
    try {


        response = await axios.get(`${baseUrl}/dashboard/entitiesForCurrentMonth`);
       const allYearSummaryresponse = await axios.get(`${baseUrl}/dashboard/allYears`);
       const dataSetByCompany = await axios.get(`${baseUrl}/dashboard/allEntityByCompany/graph`);
       const frequentlyBought = await axios.get(`${baseUrl}/dashboard/frequentlyBoughtDetailedMono/10`);
      const topNItemsOfHighestPriced = await axios.get(`${baseUrl}/dashboard/highestPricedEntities`);
      if(topNItemsOfHighestPriced?.data){
        setTopNHigh(topNItemsOfHighestPriced?.data?.data);
        console.log()
       }

       if(frequentlyBought?.data){
        setFrequentlyBoughtData(frequentlyBought?.data);
       }

       if(dataSetByCompany?.data){
        setCompanyGraphData(dataSetByCompany.data);
       }
 if(response?.data?.data){
setAllYearGraphData(allYearSummaryresponse?.data?.data);
 }

      if (response?.data?.totalAmountSpentOnAllSoFar) {   

        const formattedData = response?.data?.items?.map(item => {
          return {
            ...item,
            companies: item?.companies?.map(company => {
              const formattedMinDate = formatDate(company?.min?.purchaseDate);
              if (formattedMinDate) {
                console.log("Formatted date:", formattedMinDate);
              } else {
                console.log("Invalid date string:", company?.min?.purchaseDate);
              }
            const formattedMaxDate = formatDate(company?.max?.purchaseDate);
              if (formattedMaxDate) {
                console.log("Formatted date:", formattedMaxDate);
              } else {
                console.log("Invalid date string:", company?.max?.purchaseDate);
              }
              return {
                ...company,
                min: {
                  ...company?.min,
                  purchaseDate: formattedMinDate,
                },
                max: {
                  ...company?.max,
                  purchaseDate: formattedMaxDate,
                },
              };
            }),
          };
        });  
        setStatisticsData({
          ...response?.data,
          items: formattedData,
        });
      } else {
        navigate('/no-inventory');
      }
    } catch (error) {
      console.error(error);
    } finally {
    
     
      setIsLoading(false);
    }
  }, [baseUrl, navigate]);


  useEffect(() => {
    if (!didFetchRef.current) {
      didFetchRef.current = true;
      fetchItems();
    }
  }, [fetchItems]);

  

  const companyGraphDataOptions = {
    plugins: {
      legend: {
        position: "right",
        labels: {
          boxWidth: 10,
        },
      },
      datalabels: {
        formatter: (value) => {
     
          let sum = 0;
          let dataArr = companyGraphData?.datasets[0].data;
          if (dataArr) {
                    dataArr.forEach((data) => {
                        sum += data;
                    });
                }
          let percentage = ((value * 100) / sum).toFixed(2) + "%";
          return percentage;
        },
        color: (context) => {
          // Get the index of the current label
          let dataIndex = context.dataIndex;
          // Get the color array from the dataset
          let colors = companyGraphData?.datasets[0]?.color;
          if (!colors || !colors[dataIndex]) {
                    return 'black'; // Or any other default color
                }
          return colors[dataIndex];
      },
        labels: {
          title: {
            font: {
              size: "9",
            },
          },
        },
      },
    },
  };

 
const allYearGraphDataOptions = {
    plugins: {
        legend: {
            position: "right",
            labels: {
                boxWidth: 10,
            },
        },
        datalabels: {
            formatter: (value) => {
                let sum = 0;
                // Use optional chaining to avoid accessing properties of undefined
                let dataArr = allYearGraphData?.datasets[0]?.data;
                // Check if dataArr is not undefined before trying to map over it
                if (dataArr) {
                    dataArr.forEach((data) => {
                        sum += data;
                    });
                }
                let percentage = sum !== 0 ? ((value * 100) / sum).toFixed(2) + "%" : "0%";
                return percentage;
            },
            color: (context) => {
                // Get the index of the current label
                let dataIndex = context.dataIndex;
                // Use optional chaining to avoid accessing properties of undefined
                let colors = allYearGraphData?.datasets[0]?.color;
                // Return a default color if colors array is undefined or empty
                if (!colors || !colors[dataIndex]) {
                    return 'black'; // Or any other default color
                }
                // Return the color corresponding to the current label index
                return colors[dataIndex];
            },
            labels: {
                title: {
                    font: {
                        size: "9",
                    },
                },
            },
        },
    },
};

const devicesChartOptions = {
  plugins: {
    legend: {
      position: 'top',
      labels: {
        boxWidth: 10,
      },
    },
    tooltip: {
      mode: 'index',
      intersect: true,
      callbacks: {
        label: function (tooltipItem) {
          const itemName = tooltipItem.dataset.label || 'Item'; // Use the dataset label as the item name
          const price = tooltipItem.raw.y.toFixed(2);
          return `${itemName}: $${price}`;
        },
      },
    },
  },
  maintainAspectRatio: false,
  scales: {
    x: {
     type: 'time',
      time: {
        unit: timeUnit,
        tooltipFormat: 'yyyy-MM-dd',
        displayFormats: {
          day: 'yyyy-MM-dd',
        },
      },
      ticks: {
        autoSkip: false,
      },
    },
    y: {
      stacked: false,
      beginAtZero: true,
      ticks: {
        callback: function (value) {
          return value.toFixed(2); // Ensure 2 decimal places
        },
      },
    },
  },
  elements: {
    line: {
      tension: 0,
    },
    point: {
      radius: 5,
    },
  },
};
const sortedData = statisticsData?.data?.datasets?.map(dataset => {
  return {
    ...dataset,
    data: dataset.data.sort((a, b) => new Date(b.x) - new Date(a.x)),
  };
});

const chartData = {
  labels: statisticsData?.data?.labels,
  datasets: sortedData,
};
  return<>
 { isLoading ? (
    <div className='d-flex m-5 justify-content-center  grainy-gradient-intro'>
      <MDBSpinner style={{ width: '3rem', height: '3rem' }}>
        <span className='visually-hidden'>Loading...</span>
      </MDBSpinner>
    </div>
  ) : (
  

    <MDBContainer className=' text-center grainy-gradient-intro'>
      <h1 className="h3 text-center py-5 mb-0">Expense Dashboard</h1>

 {statisticsData &&      <section className='d-flex  justify-content-center text-center grainy-gradient-intro'>
        <MDBRow className='d-flex  justify-content-center text-center grainy-gradient-intro'>
          <MDBCol lg={statisticsData?.data?.labels?.length > 0 ?"6":"12"} className="mb-4 mb-lg-0">
            <MDBRow className='d-flex justify-content-center text-center grainy-gradient-intro'>
              <MDBCol lg="6" className="mb-4">
             
                 <MDBCard className="text-center">
                  <MDBCardHeader className="bg-light border-0">
                    <strong>Total</strong>
                  </MDBCardHeader>
                  <MDBCardBody>
                   
                    <h3>{statisticsData?.currencySymbol}{statisticsData?.totalAmountSpentOnAllSoFar}</h3>

                    <hr />

                    <div className="d-flex justify-content-between">
                      <div>
                        <p className="mb-2">
                          <small>Total Number Of Items</small>
                        </p>
                        <p className="mb-2 text-success">
                        <img src='https://opengrit.com/images/inventory' alt="Inventory" style={{ height: '30px' }} className='me-1 rounded'/>
                    
                          <span>{statisticsData?.numberOfItems}</span>
                        </p>
                      </div>
                      <div>
                        <p className="mb-2">
                          <small>Total Number Of Stores</small>
                        </p>
                        <p className="mb-2 text-success">
                        <img src='https://opengrit.com/images/store' alt="store" style={{ height: '30px' }}  className='me-1 rounded'/>
                          <span>{statisticsData?.numberOfStores}</span>
                        </p>
                      </div>
                    </div>
                  </MDBCardBody>
                </MDBCard>
              </MDBCol>

              <MDBCol lg="6" className="mb-4">
           {statisticsData &&   

<MDBCard className="text-center">
                  <MDBCardHeader className="bg-light border-0">
                    <strong>This Month</strong>
                  </MDBCardHeader>
                  <MDBCardBody>
                  
                    <h3>{statisticsData?.currencySymbol}{statisticsData?.totalSpentInThisPeriod}</h3>
                    <hr />

                    <div className="d-flex justify-content-between">
                      <div>
                        <p className="mb-2">
                          <small>Total Number Of Items</small>
                        </p>
                        <p className="mb-2 text-success">
                        <img src='https://opengrit.com/images/inventory' alt="Inventory" style={{ height: '30px' }} className='me-1 rounded'/>
                    
                          <span>{statisticsData?.numberOfItemsInthisPeriod}</span>
                        </p>
                      </div>
                      <div>
                        <p className="mb-2">
                          <small>Total Number Of Stores</small>
                        </p>
                        <p className="mb-2 text-success">
                        <img src='https://opengrit.com/images/store' alt="store" style={{ height: '30px' }}  className='me-1 rounded'/>
                          <span>{statisticsData?.numberOfStoresInThisPeriod}</span>
                        </p>
                      </div>
                    </div>
                  </MDBCardBody>
                </MDBCard> }
              </MDBCol>
            </MDBRow>

            <MDBRow className='d-flex justify-content-center text-center grainy-gradient-intro'>
            <MDBRow lg={statisticsData?.data?.labels?.length > 0 ?"6":"12"} className="mb-4 mb-lg-0">
              { allYearGraphData && allYearGraphData.labels && allYearGraphData.labels.length > 0 &&
          <MDBCol lg="6" className="mb-4">
                <MDBCard className="text-center">
                <MDBCardHeader className="bg-light border-0">
                    <strong>Money Spent in All Years</strong>
                  </MDBCardHeader>
                  <MDBCardBody>
                    <MDBChart id="year"
                      type="doughnut"
                      data={allYearGraphData}
                      options={allYearGraphDataOptions}
                      datalabels
                    />
                  </MDBCardBody>
                </MDBCard>
              </MDBCol>}

      {companyGraphData && companyGraphData.labels && companyGraphData.labels?.length > 0 &&
        <MDBCol lg="6" >
                <MDBCard className="text-center">
                <MDBCardHeader className="bg-light border-0">
                    <strong>Money Spent in Each Store</strong>
                  </MDBCardHeader>
                  <MDBCardBody>
                    <MDBChart
                      type="doughnut"
                      data={companyGraphData}
                      options={companyGraphDataOptions}
                      datalabels
                    />
                  </MDBCardBody>
                </MDBCard>
              </MDBCol>}
              </MDBRow>
            </MDBRow>
          </MDBCol>
{/*         
          {
  statisticsData?.data && statisticsData?.data?.labels && statisticsData?.data?.labels?.length > 0 && 
        <MDBCol lg="6" className="mb-4">
          <MDBCard className="text-center">
            <MDBCardHeader className="bg-light border-0">
              <strong>Price Trend of Items of Current Month</strong>
            </MDBCardHeader>
            <MDBCardBody>
              <div className="chart" style={{ height: '390px' }}>
              <MDBChart
                  type="line"
                  data={{
                    labels: statisticsData.data.labels,
                    datasets: statisticsData.data.datasets
                  }}
                  options={devicesChartOptions}
                />
              </div>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>} */}

{
  statisticsData?.data && statisticsData?.data?.labels && statisticsData?.data?.labels?.length > 0 && (
    <MDBCol lg="6" className='justify-content-center text-center grainy-gradient-intro'>
      <MDBCard className="text-center">
        <MDBCardHeader className="bg-light border-0">
          <strong>Price Trend of Items of Current Month</strong>
        </MDBCardHeader>
        <MDBCardBody>
          <div className="chart" style={{ height: "530px" }}>
            <MDBChart
              type="line"
              data={chartData}
              options={{
                maintainAspectRatio: false,
                scales: {
                  x: {
                    type: 'time',
                    time: {
                      unit: 'day',
                      tooltipFormat: 'yyyy-MM-dd',
                      displayFormats: {
                        day: 'yyyy-MM-dd'
                      }
                    },
                    ticks: {
                      autoSkip: false,
                    }
                  },
                  y: {
                    beginAtZero: true,
                    stacked: false,
                    ticks: {
                      callback: function(value) {
                        return value.toFixed(2); // Ensure 2 decimal places
                      }
                    }
                  }
                },
                plugins: {
                  legend: {
                    display: true,
                    position: 'top'
                  },
                  tooltip: {
                    mode: 'nearest',
                    intersect: true,
                    callbacks: {
                      label: function(tooltipItem) {
                        const date = tooltipItem.raw.x;
                        const itemName = tooltipItem.dataset.label || 'Item'; // Use the dataset label as the item name
                        const price = tooltipItem.raw.y.toFixed(2);
                        return `${itemName}: $${price}`;
                      }
                    }
                  }
                },
                elements: {
                  line: {
                    tension: 0
                  },
                  point: {
                    radius: 5
                  }
                }
              }}
            />
          </div>
        </MDBCardBody>
      </MDBCard>
    </MDBCol>
  )
}  


        </MDBRow>
      </section> }

     { frequentlyBoughtData && frequentlyBoughtData?.entities && frequentlyBoughtData?.entities?.length > 0 &&
       
       
       <section className='d-flex  justify-content-center text-center grainy-gradient-intro'>
       <MDBCard >
         <MDBCardHeader className="text-center py-3 bg-light border-0">
           <strong>{frequentlyBoughtData?.entities?.length === 1 ? 'Frequently Bought Item' : 'Top Frequently Bought Items'}</strong>
         </MDBCardHeader>
         <MDBCardBody>
           <div className="table-responsive">
             <MDBTable hover className="text-nowrap">
               <thead>
                 <tr>
                   <th scope="col"></th>
                   <th scope="col">{frequentlyBoughtData?.currencySymbol} Price(s)</th>
                   <th scope="col">#Times Bought</th>
                   <th scope="col">Weight ({frequentlyBoughtData?.wtMetrics})</th>
                   <th scope="col">Store(s)</th>
                   <th scope="col">{frequentlyBoughtData?.currencySymbol} TotalSpent</th>
                   <th scope="col">Date(s) Bought On</th>
                   <th scope="col">Original Name(s)</th>
                 </tr>
               </thead>
               <tbody>
                 {frequentlyBoughtData?.entities?.map((item, index) => (
                   <tr key={index}>
                     <th scope="row">{item.name}</th>
                     <td>
                       <MDBTypography listUnStyled className='mb-0'>
                         {item?.pricess?.map((price, pInd) => (
                           <li key={pInd}>{`${item.currencySymbol}${price.price}`}</li>
                         ))}
                       </MDBTypography>
                     </td>
                     <td>
                       <MDBTypography listUnStyled className='mb-0'>
                         {item?.pricess?.flatMap((price, pInd) => (
                           price?.qtys?.map((qty, qInd) => (
                             <li key={`${pInd}-${qInd}`}>{qty.numberOfItems}</li>
                           ))
                         ))}
                       </MDBTypography>
                     </td>
                     <td>
  <MDBTypography listUnStyled className='mb-0'>
    {item?.pricess?.flatMap((price, pInd) => (
      price?.qtys?.map((qty, qInd) => {
        const totalWeight = qty?.weights?.reduce((acc, weight) => acc + weight.weight, 0);
        const metrics = qty?.weights?.[0]?.metrics; // Assuming all weights have the same metrics
        return (
          <li key={`${pInd}-${qInd}`}>{`${totalWeight} ${metrics}`}</li>
        );
      })
    ))}
  </MDBTypography>
</td>

   

                     <td>
                       <MDBTypography listUnStyled className='mb-0'>
                       {item?.pricess?.flatMap((price, pInd) => (
                          
                          <li key={`${pInd}`}>{price.companyName}</li>
                       
                      ))}
                       </MDBTypography>
                     </td>
                     <td>{item.currencySymbol}{item.totalSpent}</td>
                     <td>
                       <MDBTypography listUnStyled className='mb-0'>
                         {item?.pricess?.flatMap((price, pInd) => (
                          
                             <li key={`${pInd}`}>{price.purchaseDate}</li>
                          
                         ))}
                       </MDBTypography>
                     </td>
                     <td>
                       <MDBTypography listUnStyled className='mb-0'>
                       {item?.pricess?.flatMap((price, pInd) => (
                          
                          <li key={`${pInd}`}>{price.originalName}</li>
                       
                      ))}
                       </MDBTypography>
                     </td>
                   </tr>
                 ))}
               </tbody>
             </MDBTable>
           </div>
         </MDBCardBody>
       </MDBCard>
     </section>
     
      
      }

  {topNHigh && topNHigh.data && topNHigh.data.length > 0 &&   <section>
        <div className="card">
          <MDBCardBody>
            <div className="mb-4 chart" style={{ height: "300px" }}>
              <MDBChart
                type="line"
                data={topNHigh}
                options={{
                  maintainAspectRatio: false,
                  scales: {
                    y: {
                      stacked: false,
                    },
                  },
                }}
              />
            </div>
          </MDBCardBody>
        </div>
      </section>}
    </MDBContainer>
  )}</>
};

export default Dashboard;
